import * as React from "react";
const SvgErrorX = (props) => (
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 .333A6.66 6.66 0 0 0 .333 7 6.66 6.66 0 0 0 7 13.667 6.66 6.66 0 0 0 13.667 7 6.66 6.66 0 0 0 7 .333Zm2.867 9.534c-.26.26-.68.26-.94 0L7 7.94 5.073 9.867a.664.664 0 1 1-.94-.94L6.06 7 4.133 5.073a.664.664 0 1 1 .94-.94L7 6.06l1.927-1.927a.664.664 0 1 1 .94.94L7.94 7l1.927 1.927a.676.676 0 0 1 0 .94Z"
      fill="#FF5B5B"
    />
  </svg>
);
export default SvgErrorX;
